
























































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { RepeatType } from '@/API';

@Component
export default class RepeatTypeSelect extends Vue {
  @Prop()
  private label!: string;

  @Prop()
  private repeatTypeOptions!: { [key: string]: any };

  @Prop()
  private week!: { [key: string]: string };

  @Prop()
  private selectedRepeatType!: RepeatType;

  @Prop()
  private selectedDays!: number[];

  @Prop()
  private selectedWeekdays!: number[];

  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;

  private selectedRepeatTypeValue: RepeatType = RepeatType.NoRepeat;

  private selectedDaysValue: number[] = [];

  private selectedWeekdaysValue: number[] = [];

  private weekly: RepeatType = RepeatType.Weekly;
  private monthly: RepeatType = RepeatType.Monthly;

  public async created(): Promise<void> {
    this.selectedRepeatTypeValue = this.selectedRepeatType;
    this.selectedDaysValue = this.selectedDays;
    this.selectedWeekdaysValue = this.selectedWeekdays;
  }

  @Emit('changedRepeatType')
  private onChangeRepeatType(selectedRepeatType: RepeatType): void {}

  @Emit('changedWeekdays')
  private onChangeWeekdays(): number[] {
    return this.selectedWeekdaysValue;
  }

  @Emit('changedDays')
  private onChangeDays(): number[] {
    return this.selectedDaysValue;
  }
}
